/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateWhatsAppMessageDataStatusSchema = z.enum(['pending', 'sent', 'delivered', 'read', 'failed'])

export type CandidateWhatsAppMessageDataStatusSchema = z.infer<typeof candidateWhatsAppMessageDataStatusSchema>
